// Persists commercial activation records in browser storage for the current app flow.
import type { CommercialActivationRecord, CommercialActivationRepository } from '../core/activationTypes';

const STORAGE_KEY = 'sportbook:commercial-activations';

function readStorage(): CommercialActivationRecord[] {
  if (typeof window === 'undefined') {
    return [];
  }

  const raw = window.localStorage.getItem(STORAGE_KEY);
  if (!raw) {
    return [];
  }

  try {
    return JSON.parse(raw) as CommercialActivationRecord[];
  } catch {
    return [];
  }
}

function writeStorage(records: CommercialActivationRecord[]): void {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(records));
}

// Clears guest activation remnants so local checkout state cannot leak across auth sessions.
export function clearLocalStorageCommercialActivations(): void {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.removeItem(STORAGE_KEY);
}

export function createLocalStorageCommercialActivationRepository(): CommercialActivationRepository {
  return {
    async getAll() {
      return readStorage();
    },
    async saveAll(records: CommercialActivationRecord[]) {
      writeStorage(records);
    },
  };
}
